import axios from 'axios';
import {VariantResponseModel, AllVariantResponseModel,VariantStatusWiseResponseModel,TaxesDto,TaxesResponseModel,AllTaxesResponseModel, TaxIdRequest, TaxDropDownDto, TaxDropDownResponse} from '@gtpl/shared-models/masters';
import connection from './connection';

export class TaxesService {
URL = connection.DEPLOY_URL + '/taxes';

  async createTax(tax: TaxesDto): Promise<TaxesResponseModel> {
    console.log(tax);
      return await axios.post(this.URL + '/createTax',tax)
          .then(res => {
              return res.data
          })
  }
  async  updateTax(tax:  TaxesDto): Promise<TaxesResponseModel> {
    return await axios.post(this.URL + '/updateTax', tax)
           .then(res => {
               return res.data
           })
}
  async getAllTaxes(): Promise<AllTaxesResponseModel> {
    return await axios.post(this.URL + '/getAllTaxes')
        .then(res => {
            return res.data
        })     
}
async  ActivateOrDeactivateTax(taxDto: TaxesDto): Promise<VariantResponseModel> {
    //   console.log(State.stateCode);
      return await axios.post(this.URL + '/activateOrDeactivateTax', taxDto)
              .then(res => {
                  return res.data
              })
  }
//   async  getAllActiveVariants(): Promise<AllVariantResponseModel> {
//     return await axios.post(this.URL + '/getAllActiveVariants')
//         .then(res => {
//             return res.data
//         })
  async getAllActiveTaxes(): Promise<AllTaxesResponseModel> {
    return await axios.post(this.URL + '/getAllActiveTaxes')
        .then(res => {
            return res.data
        })     
  }

  async getActiveTaxDropDown(): Promise<TaxDropDownResponse> {
    return await axios.post(this.URL + '/getActiveTaxDropDown')
        .then(res => {
            return res.data
        })     
  }
  
  async getTaxForId(req:TaxIdRequest): Promise<TaxDropDownDto> {
    return await axios.post(this.URL + '/getTaxForId', req)
        .then(res => {
            return res.data
        })     
  }

  async getTaxForNoTax(): Promise<TaxDropDownDto> {
    return await axios.post(this.URL + '/getTaxForNoTax')
        .then(res => {
            return res.data
        })     
  }
  async getDefaultTaxForPO(): Promise<TaxDropDownDto> {
    return await axios.post(this.URL + '/getDefaultTaxForPO')
        .then(res => {
            return res.data
        })     
  }
}


